import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import PercentageBar from "@public-client/Components/Charts/PercentageBar.vue";
export default {
  components: {
    PercentageBar
  },
  props: {
    domainIndicator: {
      type: Object,
      default() {
        return {};
      }
    },
    domain: {
      type: Object,
      default() {
        return {};
      }
    },
    fact: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      designation: {}
    };
  },
  computed: {
    percentage() {
      let percent = Math.round(this.fact.MeetsCount / this.fact.PossibleCount * 100);
      return Number.isNaN(percent) ? 0 : percent;
    },
    stateFact() {
      let stateSummary = this.$store.getters.stateSummary;
      return stateSummary && stateSummary.Facts ? stateSummary.Facts.find(x => x.DomainIndicatorId === this.domainIndicator.DomainIndicatorId) : null;
    },
    statePercentage() {
      return this.stateFact && this.stateFact.MeetsCount > 0 && this.stateFact.PossibleCount > 0 ? Math.round(this.stateFact.MeetsCount / this.stateFact.PossibleCount * 100) : 0;
    }
  }
};